<template>
  <div class="registration h100" v-if="infoEnb" v-loading="loading">
    <div class="registration-form">
      <h3>暂未开始报名</h3>
    </div>
    <div class="registration-form">
      <h6>报名时间为:{{ timeData.registStartTime }} 至 {{ timeData.registEndTime }}</h6>
    </div>
  </div>
  <div class="registration" v-else-if="isSubmit" v-loading="loading">
    <div class="registration-form">
      <el-form label-width="auto" :model="formData" ref="formData" v-loading="loading" :rules="rules">
        <h5 class="registration-title">基本信息</h5>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="formData.name" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-select v-model="formData.gender" placeholder="请选择性别" clearable style="width: 100%">
            <el-option label="男" value="MALE"></el-option>
            <el-option label="女" value="FEMALE"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCardNumber">
          <el-input v-model="formData.idCardNumber" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="手机号" prop="cellPhoneNumber">
          <el-input v-model="formData.cellPhoneNumber" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="职业" prop="occupation">
          <el-select v-model="formData.occupation" clearable filterable placeholder="请选择职业" style="width: 100%">
            <el-option v-for="(val, key) in occupations" :key="key" :label="val" :value="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学历" prop="education">
          <el-select v-model="formData.education" clearable filterable placeholder="请选择学历" style="width: 100%">
            <el-option v-for="(val, key) in educations" :key="key" :label="val" :value="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="民族" prop="nation">
          <el-select v-model="formData.nation" clearable filterable placeholder="请选择民族" style="width: 100%">
            <el-option v-for="(val, key) in nations" :key="key" :label="val" :value="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="政治面貌" prop="politicalOutlook">
          <el-select v-model="formData.politicalOutlook" clearable filterable placeholder="请选择" style="width: 100%">
            <el-option v-for="(val, key) in politics" :key="key" :label="val" :value="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="户籍类型" prop="householdRegisterType">
          <el-select v-model="formData.householdRegisterType" clearable filterable placeholder="请选择"
            style="width: 100%">
            <el-option v-for="(val, key) in koseki" :key="key" :label="val" :value="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="籍贯" prop="nativePlaceCity">
          <el-cascader v-model="formData.nativePlace" :options="provOptions" :props="{ label: 'text' }"
            @change="nativePlaceChange" clearable filterable style="width: 100%"></el-cascader>
        </el-form-item>
        <el-form-item label="身份证住址" prop="idCardAddress">
          <el-input v-model="formData.idCardAddress" placeholder="请输入身份证住址" clearable></el-input>
        </el-form-item>
        <el-form-item label="现居住地" prop="presentAddress">
          <el-input v-model="formData.presentAddress" placeholder="请输入现居住地" clearable></el-input>
        </el-form-item>
        <el-form-item label="登记照">
          <el-upload ref="upload" class="avatar-uploader" action="#" :multiple="false" :show-file-list="false"
            :auto-upload="false" :on-change="onChange">
            <img v-if="formData.studentScenePhoto" :src="formData.studentScenePhoto" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <h5 class="registration-title">报名信息</h5>
        <el-form-item label="主考学校" prop="schoolId">
          <el-select v-model="formData.schoolId" clearable filterable placeholder="请选择主考学校" style="width: 100%"
            disabled>
            <el-option v-for="(item, index) in schoolList" :key="index" :label="item.code + '-' + item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="教学点" prop="teachPointId">
          <el-select v-model="formData.teachPointId" clearable filterable placeholder="请选择教学点" style="width: 100%"
            disabled>
            <el-option v-for="(item, index) in teachPointList" :key="index" :label="item.code + '-' + item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="招生批次" prop="admissionBatchId">
          <el-select v-model="formData.admissionBatchId" clearable filterable placeholder="请选择招生批次" style="width: 100%"
            disabled>
            <el-option v-for="(item, index) in admissionBatchList" :key="index"
              :label="item.schoolCode + '-' + item.schoolName + '-' + item.annual + '-' + item.season"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学年制" prop="studyYearId">
          <el-select v-model="formData.studyYearId" clearable filterable placeholder="请选择学年制" style="width: 100%"
            @change="handleStudyYear">
            <el-option v-for="(item, index) in studyYearList" :key="index"
              :label="item.studyYear.studyModeName + '-' + item.studyYear.edulevelName + '-' + item.studyYear.year"
              :value="item.studyYear.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业" prop="specialtyId">
          <el-select v-model="formData.specialtyId" clearable filterable placeholder="请选择专业" style="width: 100%">
            <el-option v-for="(item, index) in specialtyList" :key="index"
              :label="item.code + '-' + item.name + (item.round ? '-' + item.round : '')" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-row>
            <el-input v-model="formData.code" placeholder="请输入验证码" style="    width: 75%;" class="mr-2" />

            <img :src="verificationImageUrl" alt="" @click="verificationCode" style="cursor: pointer; width: 100px;">
          </el-row>
        </el-form-item>
        <div class="d-flex align-items-center justify-content-center flex-column">
          <div class="mx-1 registration-tip">注意:非正式报名,只做意向登记</div>
          <el-button class="registration-button" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
        </div>
      </el-form>
      <el-dialog title="报名须知" :visible.sync="dialogFormVisible" width="90%">
        <div class="notice">
          <div v-html="timeData.notice"></div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
  <div class="registration h100" v-else v-loading="loading">
    <div class="registration-form">
      <h3>信息已提交,请等待审核!</h3>
    </div>
  </div>
</template>

<script>
import provOptions from "@/data/Province";
import cityData from "@/data/City";
export default {
  name: 'Registration',
  data () {
    return {
      provOptions,
      cityData,
      verificationImageUrl: '',
      schoolList: [],
      teachPointList: [],
      admissionBatchList: [],
      studyYearList: [],
      specialtyList: [],
      formData: {
        signUpId: '',
        studentScenePhoto: '',
        schoolId: '',
        teachPointId: '',
        admissionBatchId: '',
        nativePlace: '',
        nativePlaceCity: '',
        nativePlaceProvince: '',
        code: ''
      },
      timeData: {},
      educations: {
        PRIMARY_SCHOOL: '小学',
        MIDDLE_SCHOOL: '初中',
        SECONDARY_SPECIALIZED_SCHOOL: '中专',
        HIGH_SCHOOL: '高中',
        JUNIOR_COLLEGE: '大专',
        UNDERGRADUATE: '本科',
        MASTER: '硕士',
        DOCTOR: '博士'
      },
      occupations: {
        ZY_211: '未采集',
        ZY_216: '企业负责人',
        ZY_217: '军人',
        ZY_218: '待业、失业及无业人员',
        ZY_219: '科学研究人员',
        ZY_220: '农业技术人员',
        ZY_221: '飞机和船舶技术人员',
        ZY_222: '卫生专业技术人员',
        ZY_223: '经济业务人员',
        ZY_224: '金融业务人员',
        ZY_225: '法律专业人员',
        ZY_119: '教学人员',
        ZY_118: '学生',
        ZY_226: '文学艺术工作人员',
        ZY_227: '体育工作人员',
        ZY_228: '新闻出版、文化工作人员',
        ZY_229: '宗教职业者',
        ZY_230: '其他专业技术人员',
        ZY_231: '行政办公人员',
        ZY_232: '安全保卫和消防人员',
        ZY_233: '邮政和电信业务人员',
        ZY_234: '其他办事人员和有关人员',
        ZY_235: '购销人员',
        ZY_200: '工程技术人员',
        ZY_236: '仓储人员',
        ZY_237: '餐饮服务人员',
        ZY_238: '饭店、旅游及健身娱乐场所服务人',
        ZY_239: '运输服务人员',
        ZY_240: '医疗卫生辅助服务人员',
        ZY_241: '社会服务和居民生活服务人员',
        ZY_242: '其他商业、服务业人员',
        ZY_243: '种植业生产人员',
        ZY_244: '林业生产及野生动植物保护人员',
        ZY_245: '畜牧业生产人员',
        ZY_201: '不便分类的其他从业人员',
        ZY_246: '渔业生产人员',
        ZY_247: '水利设施管理养护人员',
        ZY_248: '其他农、林、牧、渔、水利业生产',
        ZY_249: '勘测及矿物开采人员',
        ZY_250: '金属冶炼、轧制人员',
        ZY_251: '化工产品生产人员',
        ZY_252: '机械制造加工人员',
        ZY_253: '机电产品装配人员',
        ZY_254: '机械设备修理人员',
        ZY_255: '电力设备安装、运行、检修及供电',
        ZY_256: '电子元器件与设备制造、装配、调',
        ZY_257: '橡胶和塑料制品生产人员',
        ZY_258: '纺织、针织、印染人员',
        ZY_259: '裁剪、缝纫和皮革、毛皮制品加工',
        ZY_260: '粮油、食品、饮料生产加工及饲料',
        ZY_261: '烟草及其制品加工人员',
        ZY_262: '药品生产人员',
        ZY_263: '木材加工、人造板生产、木制品制',
        ZY_264: '建筑材料生产加工人员',
        ZY_265: '玻璃、陶瓷、搪瓷及其制品生产加',
        ZY_212: '中国共产党中央委员会和地方各级',
        ZY_266: '广播影视制品制作、播放及文物保',
        ZY_267: '印刷人员',
        ZY_268: '工艺、美术品制作人员',
        ZY_269: '文化教育、体育用品制作人员',
        ZY_270: '工程施工人员',
        ZY_271: '运输设备操作人员及有关人员',
        ZY_272: '环境监测与废物处理人员',
        ZY_273: '检验、计量人员',
        ZY_274: '其他生产、运输设备操作人员',
        ZY_213: '国家机关及其工作机构负责人',
        ZY_214: '民主党派和社会团体及其工作机构',
        ZY_215: '事业单位负责人'
      },
      nations: {
        HAN: '汉族',
        MONGOL: '蒙古族',
        HUI: '回族',
        TIBETAN: '藏族',
        UYGHUR: '维吾尔族',
        MIAO: '苗族',
        YI: '彝族',
        ZHUANG: '壮族',
        BUYEI: '布依族',
        KOREAN: '朝鲜族',
        MANCHU: '满族',
        DONG: '侗族',
        YAO: '瑶族',
        BAI: '白族',
        TUJIA: '土家族',
        HANI: '哈尼族',
        KAZAK: '哈萨克族',
        DAI: '傣族',
        LI: '黎族',
        LISU: '傈僳族',
        VA: '佤族',
        SHE: '畲族',
        GAOSHAN: '高山族',
        LAHU: '拉祜族',
        SUI: '水族',
        DONGXIANG: '东乡族',
        NAXI: '纳西族',
        JINGPO: '景颇族',
        KIRGIZ: '柯尔克孜族',
        TU: '土族',
        DAUR: '达斡尔族',
        MULAO: '仫佬族',
        QIANG: '羌族',
        BLANG: '布朗族',
        SALAR: '撒拉族',
        MAONAN: '毛南族',
        GELAO: '仡佬族',
        XIBE: '锡伯族',
        ACHANG: '阿昌族',
        PUMI: '普米族',
        TAJIK: '塔吉克族',
        NU: '怒族',
        UZBEK: '乌孜别克族',
        RUSSIANS: '俄罗斯族',
        EWENKI: '鄂温克族',
        DEANG: '德昂族',
        BONAN: '保安族',
        YUGUR: '裕固族',
        GIN: '京族',
        TATAR: '塔塔尔族',
        DERUNG: '独龙族',
        OROQEN: '鄂伦春族',
        HEZHEN: '赫哲族',
        MONBA: '门巴族',
        LHOBA: '珞巴族',
        JINO: '基诺族',
        OTHER: '其他',
        FOREIGN_COUNTRY: '外国血统中国籍人士'
      },
      politics: {
        LEAGUE_MEMBER: '团员',
        PARTY_MEMBER: '党员',
        MASSES: '群众'
      },
      koseki: {
        COUNTRYSIDE: '农村',
        TOWN: '城镇'
      },
      rules: {
        cellPhoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: this.validatePhone, trigger: 'blur' },
        ],
        schoolId: [{ required: true, message: '请选择主考学校', trigger: 'change' }],
        teachPointId: [{ required: true, message: '请选择教学点', trigger: 'change' }],
        admissionBatchId: [{ required: true, message: '请选择招生批次', trigger: 'change' }],
        studyYearId: [{ required: true, message: '请选择学年制', trigger: 'change' }],
        specialtyId: [{ required: true, message: '请选择专业', trigger: 'change' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        occupation: [{ required: true, message: '请选择职业', trigger: 'change' }],
        education: [{ required: true, message: '请选择学历', trigger: 'change' }],
        idCardNumber: [
          { required: true, message: '请输入身份证' },
          {
            pattern: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/,
            message: '请输入正确的身份证'
          }
        ],
        nation: [{ required: true, message: '请选择民族', trigger: 'change' }],
        politicalOutlook: [{ required: true, message: '请选择政治面貌', trigger: 'change' }],
        householdRegisterType: [{ required: true, message: '请选择户籍类型', trigger: 'change' }],
        nativePlaceCity: [{ required: true, message: '请选择籍贯', trigger: 'change' }],
        idCardAddress: [{ required: true, message: '请输入身份证上的住址', trigger: 'blur' }],
        presentAddress: [{ required: true, message: '请输入现居住地地址', trigger: 'blur' }],
        studentScenePhoto: [{ required: true, message: '请上传登记照' }],
        code: [{ required: true, message: '请输入验证码' }],
      },
      loading: false,
      isSubmit: true,
      infoEnb: false,
      dialogFormVisible: false,
    };
  },
  computed: {

  },
  created () {
  },
  async mounted () {
    this.provOptions.forEach((item, index) => {
      item.children = this.cityData[item.value]
    })
    if (this.$route.query) {
      this.formData.schoolId = Number(this.$route.query.schoolName)
      this.formData.admissionBatchId = Number(this.$route.query.batchName)
      this.formData.teachPointId = Number(this.$route.query.teachPointName)
    } else {
      return
    }
    try {
      this.loading = true;
      this.timeAndNotice();
      this.getSchoolData();
      this.getTeachPointData();
      this.admissionBatchData();
      this.studyYearData();
      this.specialtyData();
      this.verificationCode();
    } catch (error) {

    } finally {
      this.loading = false;
    }
  },
  methods: {
    async timeAndNotice () {
      this.formData.signUpId = this.$route.query.signUpId
      const params = {
        id: this.formData.signUpId
      }
      const { data } = await this.axios.get(`/signupconfig/timeAndNotice`, { params });
      this.timeData = data.data || {}
      if (this.timeData.notice && this.timeData.notice != '<p><br></p>') {
        this.dialogFormVisible = true;
      }
      const startTime = new Date(this.timeData.registStartTime);
      const endTime = new Date(this.timeData.registEndTime);
      const now = new Date();
      if (now.getTime() < startTime) {
        this.infoEnb = true;
      } else if (now.getTime() > endTime) {
        this.infoEnb = true;
      } else {
        this.infoEnb = false;
      }
    },
    async verificationCode () {
      this.formData.randomStr = new Date().getTime();
      this.verificationImageUrl = process.env.VUE_APP_BASE_URL + `/comm/verification/code?randomStr=` + this.formData.randomStr;
    },
    async getSchoolData () {
      const { data } = await this.axios.get(`/school/select`, {});
      this.schoolList = data.data
    },
    async getTeachPointData () {
      const params = {
        size: 99999,
        schoolId: this.formData.schoolId
      }
      const { data } = await this.axios.get(`/teachPoint/page1`, { params });
      this.teachPointList = data.data.records
    },
    async admissionBatchData () {
      const params = {
        size: 99999,
        schoolId: this.formData.schoolId,
        teachPointId: this.formData.teachPointId,
        admissionBatchId: this.formData.admissionBatchId,
      }
      const { data } = await this.axios.get(`/admissionbatch/page1`, { params });
      this.admissionBatchList = data.data.records
    },
    async studyYearData () {
      const params = {
        disabled: false,
        size: 99999,
        schoolId: this.formData.schoolId,
        teachPointId: this.formData.teachPointId,
        admissionBatchId: this.formData.admissionBatchId,
      }
      const { data } = await this.axios.get(`/studyYear/config/list`, { params });
      this.studyYearList = data.data.records
    },
    async specialtyData () {
      const params = {
        disabled: false,
        size: 99999,
        schoolId: this.formData.schoolId,
        teachPointId: this.formData.teachPointId,
        admissionBatchId: this.formData.admissionBatchId,
        studyYearId: this.formData.studyYearId,
      }
      const { data } = await this.axios.get(`/specialty/page1`, { params });
      this.specialtyList = data.data.records
    },
    /**
     * 校验手机号
     */
    validatePhone (rule, value, callback) {
      var isPhone = /^1(3\d|4[5-9]|5[0-35-9]|6[2567]|7[0-8]|8\d|9[0-35-9])\d{8}$/;
      if (value.indexOf('****') >= 0) {
        return callback();
      }
      if (!isPhone.test(value)) {
        callback(new Error('请输入合法手机号'));
      } else {
        callback();
      }
    },
    async onChange (file) {
      // this.formData.studentScenePhoto = await this.upLoadImages64(await this.getBase64(file.raw));
      this.formData.studentScenePhoto = await this.getBase64(file.raw);
      // this.formData.fileName = file.name;
    },
    // async upLoadImages64 (src) {
    //   const { data } = await this.axios.post(`/student/upload/base64Image`, {
    //     base64Image: src
    //   });
    //   return data.url;
    // },
    getBase64 (file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    nativePlaceChange (province) {
      if (province && province.length == 2) {
        this.formData.nativePlaceProvince = province[0]
        this.formData.nativePlaceCity = province[1]
      } else {
        this.formData.nativePlaceProvince = ''
        this.formData.nativePlaceCity = ''
      }
    },
    handleStudyYear () {
      this.specialtyData()
    },
    onSubmit () {
      console.log(this.formData);

      this.$refs.formData.validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true;
            const { data } = await this.axios.post("/registerinfotemp/create/portal", { ...this.formData, signUpStatus: 'SAVE' });
            if (data.ok) {
              this.$message({
                message: "提交成功",
                type: "success"
              });
              this.formData = data.data;
              this.isSubmit = false;
              // this.$refs.upload.clearFiles();
              // this.$refs.formData.resetFields();
            } else {
              this.$message({
                message: data.msg,
                type: "error"
              });
            }
            this.loading = false;
          } catch (error) {
          }
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.h100 {
  height: 100%;
}

.notice {
  max-height: 500px;
  overflow-y: scroll;
}

.registration {
  width: 100%;
  background-color: #fff;
  padding: 1rem;

  .registration-form {
    padding-top: 2rem;
    display: flex;
    justify-content: center;

    .el-form {
      width: 100%;
      max-width: 600px;
    }

    ::v-deep(.el-form-item__label) {
      font-weight: 600;
    }
  }

  .registration-title {
    font-weight: bold;
    margin: 1rem 0;
  }

  .registration-tip {
    color: #F56C6C;
    margin-bottom: 1rem;
  }

  .registration-button {
    width: 6rem;
    border-radius: .5rem;
  }
}

::v-deep(.avatar-uploader .el-upload) {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

::v-deep(.avatar-uploader .el-upload:hover) {
  border-color: #409EFF;
}

::v-deep(.avatar-uploader-icon) {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

::v-deep(.avatar) {
  width: 120px;
  height: 160px;
  display: block;
}
</style>
